export function formatPriceCents(cents: number, currency = 'AUD'): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

/**
 * What the seller actually receives: item price minus their commission,
 * plus — for a DELIVERY order — a pass-through of the shipping insurance and
 * delivery fee the buyer paid. The seller is the one who actually incurs the
 * shipping cost (paying the courier), so that portion of the buyer's
 * payment needs to reach them rather than staying with the platform; only
 * the service fee is ours. Null until sellerCommissionCents is resolved
 * (see TransactionsService.confirm on the backend).
 */
export function sellerNetPayoutCents(t: {
  amountCents: number;
  sellerCommissionCents: number | null;
  deliveryMethod: 'LOCAL_PICKUP' | 'DELIVERY';
  shippingInsuranceCents: number;
  deliveryFeeCents: number;
}): number | null {
  if (t.sellerCommissionCents === null) return null;
  const shippingPassthrough =
    t.deliveryMethod === 'DELIVERY' ? t.shippingInsuranceCents + t.deliveryFeeCents : 0;
  return t.amountCents - t.sellerCommissionCents + shippingPassthrough;
}

export function formatCondition(condition: string): string {
  return condition
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
